var exports = {
  "DZ": "Heading__r2D9Ds",
  "az": "Box__j9hwJM",
  "wy": "Box_1__UBooTp",
  "$n": "Button__s9-eBM",
  "pA": "SavedState__kbMlMG",
  "L$": "SavedStateVisible__rqcJaY",
  "UE": "Text_1__HTRpEc",
};

module.exports = exports;
